<template>
  <v-container class="max-width-1200">

    <v-row>
      <v-col class="pb-0 headline text-uppercase">
        {{ $t('company.feedback.title') }}
      </v-col>
    </v-row>
    <v-row>
      <v-col class="display-1">
        {{ $t('company.feedback.subtitle')}}
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-justify">
        {{ $t('company.feedback.text')}}
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col>

        <v-carousel
          v-model="carousel"
          hide-delimiters
          cycle
          interval="12000"
          continuous
          light>
          <v-carousel-item
            v-for="(item,index) in feedbacks"
            :key="index">
            <v-card
              class="px-4"
              flat
              tile>
              <v-row
                class="mx-0 px-4 fill-height"
                align="center"
                justify="center">
                <v-col cols="12" class="px-12">
                  <img
                    :src="item.logo"
                    loading="lazy"
                    :alt="item.company + 'logó'"
                    height="30" :width="item.width"
                    style="object-fit:contain;">
                </v-col>
                <v-col cols="12" class="px-12 quote-text" style="min-height:224px;">
                  {{ '"' + $t(item.text) + '"' }}
                </v-col>
                <v-col cols="12" class="px-12">
                  <strong>{{ item.name }}</strong><br>
                  {{ $t(item.title) }}<br>
                  {{ item.company }}
                </v-col>
              </v-row>
            </v-card>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Awards',
    extends: DataComponentBase,

    data: () => ({
      carousel: 0,
      feedbacks: [
        { logo: require("@/assets/partners/partner_wewalka.png"),         text: "company.feedback.feedback.04.text", name: "Kozma Barnabás",  title: "company.feedback.managerTitle.04",          company: "Wewalka Kft.",                width: "53"  },
        // { logo: require("@/assets/partners/partner_antennahungaria.png"), text: "company.feedback.feedback.01.text", name: "Bosits Miklós",   title: "company.feedback.managerTitle.01",           company: "Antenna Hungária Zrt." },
        // { logo: require("@/assets/partners/partner_magyartelekom.png"),   text: "company.feedback.feedback.02.text", name: "Várfalvai Csaba", title: "company.feedback.managerTitle.02",  company: "Magyar Telekom Nyrt." },
        { logo: require("@/assets/partners/partner_pannontakarek.png"),   text: "company.feedback.feedback.03.text", name: "Mórotz Gergely",  title: "company.feedback.managerTitle.03",          company: "Pannon Takarék Bank Zrt.",    width: "211" },
        { logo: require("@/assets/partners/partner_flex.png"),            text: "company.feedback.feedback.05.text", name: "Savanyú Attila",  title: "company.feedback.managerTitle.05",          company: "Flex Magyarország",           width: "73"  },
      ],
    }),

    methods: {

    },
  }
</script>
